<template>
  <div class="project-info" v-if="project">
    <!-- 项目审批 -->
    <h3 class="project-info-title">审批情况</h3>
    <el-table :data="flows" style="width: 100%">
      <el-table-column label="审批项目">
        <template slot-scope="scope">
          {{ scope.row.title }}
          <span class="red" v-if="(scope.row.title=='合同会签') && scope.row.status=='审批通过'">(合同审批通过后可直接使用合同印章)</span>
        </template>
      </el-table-column>
      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="审批提交时间" width="135px">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.createTime)"></span>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row" :approvals="scope.row.approvals" :status="scope.row.status">
          </approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px" align="right">
        <template slot-scope="scope">
          <!-- 权限 -->
          <!-- 微型工程 type==3/4 PM_6 -->
          <!-- 工程 PM_5 -->
          <!-- 合同 PM_4 -->
          <info-flow :project="project" :isLeader="isLeader" :isKxLeader="isKxLeader"
            :isCanCancel="project.isProject?((project.type==3||project.type==4)?backRole('PM_6'):backRole('PM_5')):backRole('CT_4')"
            :index="scope.row.index" :flow="scope.row"></info-flow>
        </template>
      </el-table-column>
    </el-table>

    <!-- 支付相关 -->
    <info-pay style="margin-top:25px;" v-if="project" :isContract="isContract" :projectId="project.id"
      :isParentProject="project.level==0">
    </info-pay>
  </div>
</template>
<script>
  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import InfoFlow from './infoFlow'
  import InfoPay from './infoPay'
  export default {
    mixins: [Role],
    props: ['project', 'isLeader', 'isKxLeader', 'isContract'],
    data() {
      return {
        flows: [],
        loading: false,
        // isCanCancel: false,
      }
    },
    components: {
      UserInfo,
      ApprovalStatus,
      InfoFlow,
      InfoPay,
    },
    mounted() {
      // 集合审批flow
      this.assembleFlowData()
    },
    methods: {
      // 格式化时间戳
      getDateByTime(time) {
        return window.util.getFormatDate(time, true)
      },
      // 循环flows
      foreachFlows(flows, title, index) {
        if (!flows) {
          return []
        }
        let _flows = []
        for (var i = 0; i < flows.length; i++) {
          flows[i].title = title
          flows[i].index = index
          _flows.push(flows[i])
        }
        return _flows
      },
      // 组装审批列表
      assembleFlowData() {
        this.flows = []
        this.flows = this.flows.concat(this.foreachFlows(this.project.warnTimeflows, '修改预警时间审批', "13"))
        this.flows = this.flows.concat(this.foreachFlows(this.project.applyflows, '项目申请', "2"))
        this.flows = this.flows.concat(this.foreachFlows(this.project.setupflows, '项目立项', "3"))
        if (this.project.type != 3 && this.project.type != 4) {
          this.flows = this.flows.concat(this.foreachFlows(this.project.inviteflows, '招标控制价', "4"))
        } else {
          this.flows = this.flows.concat(this.foreachFlows(this.project.inviteflows, '项目预算与设计审批', "4"))
        }
        this.flows = this.flows.concat(this.foreachFlows(this.project.inviteSignflows, '招标文件会签', "10"))
        this.flows = this.flows.concat(this.foreachFlows(this.project.contractSignflows, '合同会签', "11"))
        this.flows = this.flows.concat(this.foreachFlows(this.project.contractRecordflows, '合同备案', "11"))
        this.flows = this.flows.concat(this.foreachFlows(this.project.jdkshflows, '付款审核意见单', "5"))
        this.flows = this.flows.concat(this.foreachFlows(this.project.payflows, '款项支付审批', "14"))
        this.flows = this.flows.concat(this.foreachFlows(this.project.fqflows, '项目/合同废弃审批', "103"))
      },
    },
    watch: {
      project() {
        // 集合审批flow
        this.assembleFlowData()

        // // 根据TYPE处理是否ChildDept
        // let _isChildDept = (this.project.type == 3 || this.project.type == 4) ? true : false
        // // _isChildDept = (this.project.isProject === false) ? true : false

        // ajax.post('/flow/can/cancel', {
        //   isChildDept: _isChildDept
        // }, (res) => {
        //   // console.log(res.vo.data)
        //   // console.log(res.vo.data == "false")
        //   this.isCanCancel = res.vo.data == "false" ? false : true
        //   // console.log(this.isCanCancel)
        // })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/page/project/info.vue